/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
const scrollSnoop = require('./scroll-snoop.cjs');

const LazyLoad = function LazyLoad() {
  // lazy load images
  let active = false;

  const lazyLoad = function lazyLoad() {
    let lazyImages = [].slice.call(document.querySelectorAll('[data-lazy-background]'));

    if (lazyImages.length < 1 || active) return;

    active = true;
    setTimeout(() => {
      lazyImages.forEach((lazyImage) => {
        if ((0, scrollSnoop.default)(lazyImage)) {
          const { lazyBackground } = lazyImage.dataset;

          const url = 'url(\'' + lazyBackground + '\')';
          lazyImage.style.backgroundImage = url;
          lazyImage.removeAttribute('data-lazy-background');

          lazyImages = lazyImages.filter((image) => (image !== lazyImage));
        }
      });
      active = false;
    }, 200);
  };

  document.addEventListener('scroll', lazyLoad);
  document.addEventListener('lazy:reload', lazyLoad);
  window.addEventListener('resize', lazyLoad);
  window.addEventListener('orientationchange', lazyLoad);
  lazyLoad();
};

exports.default = LazyLoad;
